import { BulkCreateShiftmanagementUnassignedShiftUnassignedShiftsInput } from 'generated/resources/graphql'
import moment from 'moment'
import { Moment } from 'moment'

import { dateToString } from 'modules/core/lib/dates'

export interface UnassignedShiftParam {
  startAt: string
  endAt: string
  notes?: string | null
  workAreaId?: string | number | null
  locationId?: string | number | null
  extraHours?: boolean
  defaultShiftId?: number | null
  defaultShiftTitle?: string | null
  color?: string | null
  counter: number
  jobCatalogRolesIds: number[]
  jobCatalogTreeRoleUuids: string[]
  overnightShift: boolean
  allCompany: boolean
  teamsIdsVisibilities: number[]
  locationsIdsVisibilities: number[]
}

const buildUnassignedShiftParameters = (
  startTime: moment.Moment,
  endTime: moment.Moment,
  extraHours: boolean,
  notes: string | null,
  locationId: number | null,
  workAreaId: number | null,
  defaultShiftId: number | null,
  counter: number,
  jobCatalogRolesIds: number[],
  jobCatalogTreeRoleUuids: string[],
  overnightShift: boolean,
  allCompany: boolean,
  teamsIdsVisibilities: number[],
  locationsIdsVisibilities: number[],
  companyId: number
): BulkCreateShiftmanagementUnassignedShiftUnassignedShiftsInput[] => {
  const endDateTime = overnightShift ? moment(endTime.add(1, 'days').toDate()) : endTime

  const startAt = dateToString(startTime, 'backend_datetime_without_timezone')
  const endAt = dateToString(endDateTime, 'backend_datetime_without_timezone')

  return [
    {
      startAt,
      endAt,
      extraHours,
      notes,
      locationId,
      workAreaId,
      defaultShiftId,
      counter,
      jobCatalogRolesIds,
      jobCatalogTreeRoleUuids,
      allCompany,
      teamsIdsVisibilities,
      locationsIdsVisibilities,
      companyId,
    },
  ]
}

const buildAddUnassignedShiftsParameters = ({
  date,
  unparsedStartTime,
  unparsedEndTime,
  defaultShiftId,
  extraHours,
  notes,
  locationId,
  workAreaId,
  counter,
  jobCatalogRolesIds,
  jobCatalogTreeRoleUuids,
  overnightShift,
  allCompany,
  teamsIdsVisibilities,
  locationsIdsVisibilities,
  companyId,
}: {
  date: Moment
  unparsedStartTime: string | null | undefined
  unparsedEndTime: string | null | undefined
  defaultShiftId: number | null
  extraHours: boolean
  notes: string | null
  locationId: number | null
  workAreaId: number | null
  counter: number
  jobCatalogRolesIds: number[]
  jobCatalogTreeRoleUuids: string[]
  overnightShift: boolean
  allCompany: boolean
  teamsIdsVisibilities: number | null
  locationsIdsVisibilities: number | null
  companyId: number
}): BulkCreateShiftmanagementUnassignedShiftUnassignedShiftsInput[] => {
  if (!unparsedStartTime || !unparsedEndTime) return []

  const dateString = dateToString(date, 'backend')
  const startTime = moment(dateString + ' ' + unparsedStartTime)
  const endTime = moment(dateString + ' ' + unparsedEndTime)

  if (!startTime || !startTime.isValid()) return []

  if (!endTime || !endTime.isValid()) return []

  return buildUnassignedShiftParameters(
    startTime,
    endTime,
    extraHours,
    notes,
    locationId,
    workAreaId,
    defaultShiftId,
    counter,
    jobCatalogRolesIds,
    jobCatalogTreeRoleUuids,
    overnightShift,
    !allCompany ? false : allCompany,
    !teamsIdsVisibilities || allCompany ? [] : [teamsIdsVisibilities],
    !locationsIdsVisibilities || allCompany ? [] : [locationsIdsVisibilities],
    companyId
  )
}

export default buildAddUnassignedShiftsParameters
